import { api } from '../http';

export const login = data => api.post('/authentication/login', data);
export const pin = data => api.post('/authentication/pin', data);
